import {
  WSModal,
  WSModalCustomProps,
  useWSModalCustom
} from "@wingspanhq/fe-component-library";
import { MfaFactor, MfaFactorStatus } from "@wingspanhq/wingspan-api-sdk";
import { queriesMfa } from "@query";
import React, { useState } from "react";
import { FormDataPhoneNumber } from "../../../modules/Onboarding/components/FormPartialPhoneNumber";
import { mfaFactorVerifyCodeField } from "./mfaFactorEnroll";
import {
  MfaFactorEnrollForm,
  MfaFactorEnrollSubmit
} from "./MfaFactorEnrollForm";
import { MfaFactorVerifyForm } from "./MfaFactorVerifyForm";

type Props = {
  defaultEmail?: string;
  defaultPhone?: FormDataPhoneNumber;
} & WSModalCustomProps<boolean>;

type PendingFactor = { factor: MfaFactor; destination: string };

const ModalAddMfaFactor: React.FC<Props> = props => {
  const [pending, setPending] = useState<PendingFactor>();

  const [createFactor, createMeta] = queriesMfa.createMfaFactor.useMutation();
  const [verifyFactor, verifyMeta] = queriesMfa.verifyMfaFactor.useMutation();

  const handleEnroll = async (submit: MfaFactorEnrollSubmit) => {
    const factor = await createFactor({ mfaFactorCreate: submit.create });
    if (factor) {
      setPending({ factor, destination: submit.destination });
    }
  };

  const handleVerify = async (code: string) => {
    if (!pending) {
      return;
    }

    const result = await verifyFactor({
      mfaFactorId: pending.factor.id,
      mfaFactorVerifyRequest: {
        [mfaFactorVerifyCodeField(pending.factor.type)]: code
      }
    });

    if (result?.status === MfaFactorStatus.ACTIVE) {
      props.onClose(true);
    }
  };

  return (
    <WSModal
      title={pending ? "Verify this method" : "Add a verification method"}
      size="S"
      onClose={() => props.onClose(false)}
    >
      {pending ? (
        <MfaFactorVerifyForm
          type={pending.factor.type}
          destination={pending.destination}
          submitting={verifyMeta.isLoading}
          error={verifyMeta.error}
          onSubmit={handleVerify}
          onBack={() => setPending(undefined)}
        />
      ) : (
        <MfaFactorEnrollForm
          defaultEmail={props.defaultEmail}
          defaultPhone={props.defaultPhone}
          submitting={createMeta.isLoading}
          error={createMeta.error}
          onSubmit={handleEnroll}
        />
      )}
    </WSModal>
  );
};

export const useModalAddMfaFactor = () => useWSModalCustom(ModalAddMfaFactor);
